import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../Globals/styles';
import { connect } from 'react-redux';
import { routeActions } from 'redux-simple-router';
import WorkplaceDragable from './workplaceDragable';
import {
  setWorkplaceIsDragging,
  onWorkplaceEmployeeDrop,
  updateWorkplaceColor,
  removeEmployeeFromWorkplace
} from './actions'
import { showSidebarConst } from '../../Globals/constants';
import EmployeeDropable from './employeeDropable';
import { httpPut, httpDelete } from '../../Util/http';

class Workplace extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    }
  }
  openWorkplace = () => {
    //only redirect if sidebar is not open
    if (this.props.showSidebar === showSidebarConst.NOT_SHOWING)
      this.props.dispatch(routeActions.push("/afdeling/" + this.props.params.departmentId + "/arbejdssted/" + this.props.workplaceId + "/oversigt"))
  }
  setColor = (color) => {
    color = color.replace('#', '')
    var _url = process.env.REACT_APP_webApiEndPoint + `api/workplace/${this.props.workplaceId}/color?color=${color}`
    httpPut(_url)
      .then(() => {
        this.props.dispatch(updateWorkplaceColor(this.props.workplaceId, color))
        this.setState({
          show: false,
        })
      })
      .catch(() => {
        this.props.dispatch(updateWorkplaceColor(this.props.workplaceId, this.props.workplace.color))
        alert('kunne ikke ændre farve')
      })
  }
  renderColor = (color) => {
    return (
      <div
        style={{ width: '100%', backgroundColor: color, height: 25, margin: '2px 0px 2px 0px', cursor: 'pointer' }}
        onClick={(e) => {
          e.stopPropagation()
          this.setColor(color)
        }}
      >
        {'#' + this.props.workplace.color == color ?
          <i style={{ paddingTop: 7, color: 'white' }} className="fa fa-check" aria-hidden="true"></i>
          : null}
      </div>
    )
  }
  render() {
    if (!this.props.workplace) {
      console.log('workplaceNotFound', this.props.workplaceId)
      return <div></div>
    }
    const { position, workplace, workplace: { id, name, project, client, employees },
      dispatch, showSidebar, draggingWorkplace, unread } = this.props;
    if (!client) {
      console.log(id)
    }
    const cl = client || { name: 'FEJL', contact: { name: 'FEJL' } }
    var hasUnread = unread ? unread.indexOf(id) > -1 : false;
    return (
      <div style={[styles.outerContainer, draggingWorkplace === id && styles.dragging]}>
        {hasUnread ? <div style={styles.infoBtn} onClick={this.openWorkplace}><i className="fa fa-align-left" style={styles.infoIcon}></i></div> : null}
        {
          //if emp list is showing, you cannot drag the workplaces
          showSidebar === showSidebarConst.EMP_LIST ?
            null
            :
            <WorkplaceDragable
              workplace={workplace}
              position={position}
              setWorkplaceIsDragging={(id) => dispatch(setWorkplaceIsDragging(id))}
              shouldPreviewBeSmall={showSidebar !== showSidebarConst.EMP_WEEK_OVERVIEW}
            />
        }
        <div
          className={showSidebar !== showSidebarConst.EMP_WEEK_OVERVIEW ? "waves-btn" : null}
          style={[styles.container,
          (showSidebar !== showSidebarConst.EMP_WEEK_OVERVIEW && draggingWorkplace) && styles.isDragging,
          position.columnIndex === 9 && styles.isInvoiced]}
          onClick={this.openWorkplace}>
          {
            //if emp list is showing, render dropable component
            showSidebar === showSidebarConst.EMP_LIST ?
              <EmployeeDropable
                workplaceId={id}
                isEmployeeAlreadyDropped={() => { }}
                onWorkplaceEmployeeDrop={(employee) => dispatch(onWorkplaceEmployeeDrop(employee, id))}
              />
              :
              null
          }
          <div style={styles.headderContainer}>
            <div style={styles.projectHeader}>
              <div>
                {project.number}
                <br />
                {project.name}
              </div>
            </div>
          </div>
          <div style={styles.workplaceName}>
            {name}
          </div>
          <div style={styles.client}>
            {cl.name}
            <br />
            {cl.contact.name}
          </div>
          <div style={styles.employeesContainer}>
            {
              Object.keys(employees).length < 1 ?
                <div style={styles.placeholderText}> Ingen tilknyttede medarbejdere </div>
                :
                Object.keys(employees).map((employeeId) => {
                  return (
                    <div
                      key={employees[employeeId].id}
                      style={styles.employeeInitials}
                      onClick={(e) => {
                        e.stopPropagation()
                        this.setState({
                          [employeeId]: !this.state[employeeId]
                        })
                      }}
                    >
                      <div style={this.state[employeeId] === true ? { paddingLeft: 16 } : null}>
                        {this.state[employeeId] === true ? employees[employeeId].name : employees[employeeId].initials}
                      </div>
                      {this.state[employeeId] === true ?
                        <div style={{ position: 'fixed' }}>
                          <i style={{ position: 'absolute', top: -16 }} className="fa fa-times-circle"
                            onClick={(e) => {
                              e.stopPropagation()
                              if (window.confirm(`Vil du fjerne ${employees[employeeId].name} fra arbejdsstedet ${name}?`)) {
                                var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/' + this.props.workplaceId + '/rmemployee';
                                httpDelete(_url, { employeeId: employeeId })
                                  .then(() => {
                                    this.props.dispatch(removeEmployeeFromWorkplace(this.props.workplaceId, employeeId))
                                  })
                                  .catch(() => {
                                    alert('Kunne ikke fjerne medarbejder, prøv igen')
                                  })
                              } else {
                                this.setState({
                                  [employeeId]: !this.state[employeeId]
                                })
                              }
                            }}></i>
                        </div>
                        : null}
                    </div>
                  )
                })
            }
          </div>
        </div>
        <div style={{ marginTop: -8 }}
          onClick={(e) => {
            e.stopPropagation()
            this.setState({
              show: !this.state.show
            })
          }}>
          <div style={{ width: '100%', backgroundColor: this.props.workplace.color ? '#' + this.props.workplace.color : '#e2e2e2', height: 10, cursor: 'pointer' }}>
          </div>
          {this.state.show ?
            <div style={{ paddingTop: 7 }}>
              Vælg en farve
                {this.renderColor('#61BD4F')}
              {this.renderColor('#F2D600')}
              {this.renderColor('#EB5A46')}
              {this.renderColor('#C377E0')}
              {this.renderColor('#FF80CE')}
              {this.renderColor('#4d4d4d')}
              {this.renderColor('#e2e2e2')}
            </div>
            : null}
        </div>
      </div>
    );
  }
}


var styles = {
  outerContainer: {
    width: '100%',
    position: 'relative'
  },
  container: {
    textAlign: 'center',
    width: '100%',
    backgroundColor: greyScaleColors.greyLighter,
    marginBottom: '8px',
    borderRadius: '2px',
    fontSize: '12px',
    padding: '6px 12px 0px 12px',
    position: 'relative',
    transition: 'max-height 0.3s',
    display: 'block',
    whiteSpace: 'initial',
    verticalAlign: 'initial',
    zIndex: '0'
  },
  isDragging: {
    overflow: 'hidden'
  },
  headderContainer: {
    padding: '0px 20px',
    borderBottom: '1px solid ' + semanticColors.mainBackground
  },
  projectHeader: {
    fontWeight: '600',
    lineHeight: '14px',
    height: '35px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  projectHeaderSmall: {
    marginLeft: '10px',
    marginTop: '8px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  workplaceName: {
    padding: '4px 0',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  client: {
    padding: '4px 0',
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    whiteSpace: 'nowrap',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  employeesContainer: {
    minHeight: '20px',
    padding: '7px 0px 4px 0px'
  },
  employeeInitials: {
    display: 'inline-block',
    margin: '0px 1px 1px 1px',
    color: '#fff',
    height: '20px',
    lineHeight: '20px',
    width: 'auto',
    paddingLeft: 5,
    paddingRight: 5,
    backgroundColor: semanticColors.mainBackground,
    borderRadius: '2px'
  },
  dragging: {
    opacity: '0'
  },
  placeholderText: {
    color: greyScaleColors.greyLight
  },
  infoBtn: {
    cursor: 'pointer',
    position: 'absolute',
    right: '0',
    top: '0',
    width: '0',
    height: '0',
    zIndex: '2',
    borderStyle: 'solid',
    borderWidth: '0 40px 40px 0',
    borderColor: "transparent " + semanticColors.info + " transparent transparent"
  },
  infoIcon: {
    marginLeft: '22px',
    marginTop: '4px',
    color: semanticColors.text
  },
  isInvoiced: {
    backgroundColor: semanticColors.successLight
  }
}


//redux connect logic
const selectProps = (state, ownProps) => {
  return {
    unread: state.kanbanReducer.unread,
    workplace: state.kanbanReducer.workplaces[ownProps.workplaceId],
    draggingWorkplace: state.kanbanReducer.draggingWorkplace
  };
}
Workplace.propTypes = {
  workplace: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    client: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      contact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    project: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      number: PropTypes.string.isRequired
    }).isRequired,
    employees: PropTypes.object.isRequired
  }),
  workplaceId: PropTypes.string.isRequired,
  position: PropTypes.shape({
    columnIndex: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired
  }),
  showSidebar: PropTypes.oneOf(Object.keys(showSidebarConst)),
  draggingWorkplace: PropTypes.string
};

export default connect(selectProps)(Radium(Workplace));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/workplace.jsx